"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
if (process.env.BROWSER) {
    require('./index.less');
}
class NoPicItem extends React.PureComponent {
    render() {
        return React.createElement("div", { className: 'news-item no-pic-item' }, this.props.title);
    }
}
exports.default = NoPicItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBK0I7QUFDL0IsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLE9BQU8sRUFBRTtJQUNyQixPQUFPLENBQUMsY0FBYyxDQUFDLENBQUM7Q0FDM0I7QUFJRCxNQUFxQixTQUFVLFNBQVEsS0FBSyxDQUFDLGFBQTZCO0lBQy9ELE1BQU07UUFDVCxPQUFPLDZCQUFLLFNBQVMsRUFBSSx1QkFBdUIsSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBTyxDQUFDO0lBQ2hGLENBQUM7Q0FDSjtBQUpELDRCQUlDIn0=